import styled from '@emotion/styled'
import { Button as AntdButton } from 'antd'
import { ButtonProps } from 'antd/lib/button'
import { CSSProperties, ReactNode } from 'react'
import Text from '../../components/common/Text'
import color from '../../constant/colors'
import Image from './Image'

const CustomStyledAntdButton = styled(AntdButton) <{
  background: string
  bordercolor: string
  borderhover: string
}>`
  display: flex;
  justify-content: center;
  align-items: center;

  color: ${({ color }) => color};
  background: ${({ background }) => background};
  width: 100%;
  max-width: 364px;
  height: 45px;
  border-radius: 8px;
  border-color: ${({ borderhover }) => borderhover};
  // transition: outline 0.6s linear;

  :hover,
  :active,
  :focus {
    background: ${({ background }) => background};
    // border-width: 2px;
    border-color: ${({ bordercolor }) => bordercolor};
  }

  :disabled {
    background: #c1c1c1;

    :hover,
    :focus,
    :active {
      background: #c1c1c1;
    }
  }
`

const TextStyled = styled(Text)`
  display: flex;
  justify-content: center;
  align-items: center;
`

type CustomButtonProps = {
  children: ReactNode
  style?: CSSProperties
  background?: string
  textProps?: {}
  iconImage?: string
  id?: string
  fontSize?: number
  fontType?: 'Bold' | 'SemiBold' | 'Medium' | 'Text' | 'Regular'
  fontColor?: string
  borderColor?: string
} & Pick<
  ButtonProps,
  | 'block'
  | 'danger'
  | 'disabled'
  | 'ghost'
  | 'href'
  | 'htmlType'
  | 'icon'
  | 'loading'
  | 'shape'
  | 'size'
  | 'target'
  | 'type'
  | 'onClick'
>

const Button = (props: CustomButtonProps) => {
  const {
    id,
    children,
    style,
    onClick,
    disabled = false,
    textProps,
    iconImage,
    fontSize = 18,
    fontType = "Bold",
    fontColor = color.WHITE,
    borderColor = color.CHOICES_PRIMARY,
    background = color.CHOICES_PRIMARY,
    ...resProps
  } = props

  return (
    <CustomStyledAntdButton
      id={id}
      style={style}
      onClick={onClick}
      disabled={disabled}
      background={background}
      borderhover={fontColor}
      bordercolor={borderColor}
      {...resProps}
    >
      {iconImage ? <Image src={iconImage} style={{ marginRight: 8 }} /> : null}
      <TextStyled size={fontSize} type={fontType} color={fontColor} {...textProps}>
        {children}
      </TextStyled>
    </CustomStyledAntdButton>
  )
}

export default Button
